module.exports = __webpack_public_path__ + "img/close.e73fa613.svg";